import React from 'react';
import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  connecting: {
    id: 'liveChatConnecting',
    defaultMessage: 'Connecting to chat...',
  },
  error: { id: 'liveChatError', defaultMessage: 'Could not connect to chat.' },
  retry: { id: 'liveChatRetry', defaultMessage: 'Try again' },
  disconnected: { id: 'liveChatDisconnected', defaultMessage: 'Disconnected' },
});

const ChatStatus = ({ status, onRetry }) => {
  const intl = useIntl();

  if (status === 'CONNECTING' || status === 'IDLE') {
    return (
      <div className="live-chat-status">
        <div className="live-chat-spinner" />
        <span>{intl.formatMessage(messages.connecting)}</span>
      </div>
    );
  }

  if (status === 'ERROR' || status === 'DISCONNECTED') {
    return (
      <div className="live-chat-status">
        <span>
          {status === 'ERROR'
            ? intl.formatMessage(messages.error)
            : intl.formatMessage(messages.disconnected)}
        </span>
        {onRetry && (
          <button className="live-chat-retry-btn" onClick={onRetry}>
            {intl.formatMessage(messages.retry)}
          </button>
        )}
      </div>
    );
  }

  return null;
};

export default ChatStatus;
